<template>
    <div id="CustomerPurchaseOrderItemList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Customer Purchase Order Details
                        <router-link class="btn btn-success waves-effect pull-right" v-bind:to="'/order-history/list?from=customer'" >
                            <i class="hi-icon icon-flback"></i>  Back
                        </router-link>

                    </div>

                    <div class="admin-page-content customer-detail">
                        <div class="purchase-order-item-main">
                            <div class="purchase-order-item-left customer-view-main"> <!--left section-->
                                    <div>
                                        <span class="customer-detail-rv-title">Purchase Order Number:</span>
                                        <span class="customer-detail-rv">{{poNum}}</span>
                                    </div>
                                    <div>
                                        <span class="customer-detail-rv-title">Purchase Order Type:</span>
                                        <span class="customer-detail-rv">{{po_type}}</span>
                                    </div>
                                    <!-- <div>
                                        <span class="customer-detail-rv-title">From:</span>
                                        <span class="customer-detail-rv">{{from_where}}</span>
                                    </div> -->
                                    <div>
                                        <span class="customer-detail-rv-title">Customer:</span>
                                        <span class="customer-detail-rv">{{customer}}</span>
                                    </div>
                                    <!-- <div>
                                        <span class="customer-detail-rv-title">Vendor:</span>
                                        <span class="customer-detail-rv">{{vendor}}</span>
                                    </div> -->
                                    <div>
                                        <span class="customer-detail-rv-title">Oredering:</span>
                                        <span class="customer-detail-rv">{{orderingLoc}}</span>
                                    </div>
                                    <div>
                                        <span class="customer-detail-rv-title">Assigned:</span>
                                        <span class="customer-detail-rv">{{assignLoc}}</span>
                                    </div>
                                    <div>
                                        <span class="customer-detail-rv-title">Ship To:</span>
                                        <span class="customer-detail-rv">{{shipToLoc}}</span>
                                    </div>
                                    <div>
                                        <span class="customer-detail-rv-title">Order Date:</span>
                                        <span class="customer-detail-rv">{{order_date}}</span>
                                    </div>
                                    <div>
                                        <span class="customer-detail-rv-title">Due Date:</span>
                                        <span class="customer-detail-rv">{{due_date}}</span>
                                    </div>
                                    <div>
                                        <span class="customer-detail-rv-title">Delivery Date:</span>
                                        <span class="customer-detail-rv">{{delivery_date}}</span>
                                    </div>

                            </div> <!--left section-->

                            <div class="purchase-order-item-right" v-if="listDis"> <!--rigt section-->
                                    <div class="purchase-order-item-right-main">
                                        <span class="purchase-order-item-title"> Unit Price: </span>
                                        <span class="purchase-order-item-des"> {{unitPrice}} </span>
                                    </div>

                                    <div class="purchase-order-item-right-main" v-if="!showItemsColumn">
                                        <span class="purchase-order-item-title"> Add Charges: </span>
                                        <span class="purchase-order-item-des"> {{chargesTotal}} </span>
                                    </div>

                                    <div class="purchase-order-item-right-main">
                                        <span class="purchase-order-item-title"> Tax: </span>
                                        <span class="purchase-order-item-des"> {{taxAmount}} </span>
                                    </div>

                                    <div class="purchase-order-item-right-main purchase-order-item-total">
                                        <span class="purchase-order-item-title"> Total: </span>
                                        <span class="purchase-order-item-des"> {{grandTotal}} </span>
                                    </div>
                            </div> <!--rigt section-->
                        </div>

                        <p>&nbsp;</p>
                        <section class="internal-container">
                            <div class="container">
                                <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1" v-if="purchaseOrderItemsArr != undefined && purchaseOrderItemsArr.length > 0">
                                    <thead class="table table-bordered">
                                        <tr>
                                            <th v-if="!showItemsColumn">Manufacturer</th>
                                            <th v-if="!showItemsColumn">Asset Model</th>
                                            <th v-if="!showItemsColumn">Asset Pool</th>
                                            <th v-if="!showItemsColumn">Year</th>
                                            <th v-if="showItemsColumn">Part</th>
                                            <th>Quantity</th>
                                            <th>Unit Price</th>
                                            <th>Tax (%)</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(item, index) in purchaseOrderItemsArr" v-bind:key="index">
                                            <td v-if="!showItemsColumn"> {{ item.manufacturer}} </td>
                                            <td v-if="!showItemsColumn"> {{ item.model}} </td>
                                            <td v-if="!showItemsColumn"> {{ item.vehicle_pool}} </td>
                                            <td v-if="!showItemsColumn"> {{ item.year}} </td>
                                            <td v-if="showItemsColumn"> {{ item.item}} </td>
                                            <td> {{ item.quantity}} </td>
                                            <td> {{ item.unit_price}} </td>
                                            <td> {{ item.tax_percentage}} </td>
                                            <td> {{ item.total}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";
import EventBus from "././event-bus";
    

    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';
    

    

    export default {
        name: "CustomerPurchaseOrderItemList",
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",

            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            asset_value: false,
            loading:false,
            permit_value:false,
            addPermit:false,
            assetId:"",
            selectedFile:"",
            poId:"",
            poNum:"",
            vendor:"",
            orderingLoc:"",
            assignLoc:"",
            shipToLoc:"",
            unitPrice:0,
            taxAmount:0,
            chargesTotal:0,
            taxTotal:0,
            delivery_date:"",
            order_date:"",
            due_date:"",
            po_type:"",
            customer:"",
            from_where:"",
            listDis:true,
            grandTotal:0,
            purchaseOrderItemsArr:[],
            showItemsColumn:true
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_customer_purchase_order') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {
            var self = this;


            self.getPermissions();
            self.getPoInfo();
            self.loadList();

        },
        methods: {

        selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

        getPoInfo(){

            var self = this;
            var path = window.location.pathname;
            var po = path.split("/");

            $.ajax({
                    url: process.env.ROOT_API + "/customer-purchase-order/"+po[2],
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            self.poNum = data.content.po_no;
                            self.po_type = data.content.type;
                            self.from_where = data.content.from_where;
                            if(data.content.type == "Item"){
                                self.showItemsColumn = true;
                                // self.$set(self.columns[2], 'hidden', true);
                                // self.$set(self.columns[3], 'hidden', true);
                                // self.$set(self.columns[4], 'hidden', true);
                                // self.$set(self.columns[7], 'hidden', true);
                            }else{
                                self.showItemsColumn = false;
                                // self.$set(self.columns[1], 'hidden', true);
                            }
                            // alert(data.content.cust_name);
                            if(data.content.cust_name != null){
                                self.customer = data.content.custName+" | "+data.content.cusCode;
                            }else{
                                self.customer = "-"
                            }
                            if ( data.content.order_location != null && data.content.order_location != undefined && data.content.order_location != '' ){

                                self.orderingLoc = data.content.order_location +" ("+data.content.orderLocCode+")";

                            }
                            if ( data.content.assigned_location != null && data.content.assigned_location != undefined && data.content.assigned_location != '' ){

                                self.assignLoc = data.content.assigned_location+" ("+data.content.assignLocCode	+")";
                            }
                            if ( data.content.ship_location != null && data.content.ship_location != undefined && data.content.ship_location != '' ){

                                self.shipToLoc = data.content.ship_location+" ("+data.content.shipLocCode+")";
                            }
                            if(data.content.chargesTotal){
                                self.chargesTotal = data.content.chargesTotal;
                            }
                            if(data.content.taxTotal){
                                self.taxTotal = data.content.total_tax;
                            }
                            self.delivery_date = data.content.delivery_date;
                            self.order_date = data.content.order_date;
                            self.due_date = data.content.due_date;
                            self.unitPrice = data.content.unit_total;
                            self.taxAmount = data.content.total_tax;
                            self.grandTotal = data.content.grand_total;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'get-customer-po-details');
                    }
                });
        },

        loadList() {

            var self = this;

            var path = window.location.pathname;
            var po = path.split("/");
            self.poId = po[2];

            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                poId:self.poId
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/customer-purchase-order/item-list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                        self.purchaseOrderItemsArr = data.content.row;

                        if(data.content.totalRecords == 0){
                            self.listDis = false;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'customer-po-items-list');
                }
            });
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerPurchaseOrderItemList.vue